import { Injectable } from '@angular/core';
import { CounterNamesEnum } from '@shared/components/most-used/sidebar/sidebar.config';
import { BehaviorSubject } from 'rxjs';

// export type SidebarUpdateConfig = {
//   field: CounterNamesEnum;
//   value: number;
// };

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  counters: { [key in CounterNamesEnum]: BehaviorSubject<{ value: number }> } = {
    [CounterNamesEnum.REQUESTS]: new BehaviorSubject({ value: 0 }),
    [CounterNamesEnum.PROPOSALS]: new BehaviorSubject({ value: 0 }),
    [CounterNamesEnum.SUPPORT]: new BehaviorSubject({ value: 0 }),
    [CounterNamesEnum.NOTIFICATION]: new BehaviorSubject({ value: 0 }),
  };

  constructor() {}

  updateRequestsCounter(value: number) {
    this.counters.requests.next({ value });
  }

  updateSupportCounter(value: number) {
    this.counters.support.next({ value });
  }

  updateNotificationCounter(value: number) {
    this.counters.notification.next({ value });
  }

  updateProposalsCounter(value: number) {
    this.counters.proposals.next({ value });
  }
}
